import dashImg from "@/assets/images/devices/device_2.png";
import dashThumbnail from "@/assets/images/devices/device_2_thumbnail.png";
import boltImg from "@/assets/images/devices/device_3.png";
import boltThumbnail from "@/assets/images/devices/device_3_thumbnail.png";
import hydroImg from "@/assets/images/devices/device_4.png";
import hydroThumbnail from "@/assets/images/devices/device_4_thumbnail.png";

export const showcase = [
  {
    id: 2043,
    image: dashImg,
    thumbnail: dashThumbnail,
    name: "Dash T11 4G/LTE",
  },
  {
    id: 2113,
    image: boltImg,
    thumbnail: boltThumbnail,
    name: "Bolt 4G/LTE",
  },
  {
    id: 2114,
    image: hydroImg,
    thumbnail: hydroThumbnail,
    name: "Hydro 4G/LTE",
  },
];
